import { AllocationDto, GiorniLavorativiMeseAnnoDto, RevenuePlanDto, StaffExtendedDto } from '@api/client';
import { TotalsRevenuesAndGUStickyLabels } from '../../../_utils/revenue-plan.utils';
import { formatCurrency } from 'shared/utils/common.utils';

interface Props {
  fullAllocationsShown: Partial<StaffExtendedDto>[] | null | undefined;
  totalsRevenuePlanShown: RevenuePlanDto[] | null | undefined;
  giorniLavorativi: GiorniLavorativiMeseAnnoDto[] | null | undefined;
  visibleRows: { [key: string]: boolean };
}

const TotalsAllocations: React.FC<Props> = ({
  fullAllocationsShown,
  totalsRevenuePlanShown,
  visibleRows,
  giorniLavorativi,
}) => {
  const getGiorniLavorativi = (index: number) => {
    const month = fullAllocationsShown?.[0].allocazioni?.[index]?.month;
    const year = fullAllocationsShown?.[0].allocazioni?.[index]?.year;
    const workingDays = giorniLavorativi?.find((el) => el.mese === month && el.anno === year)?.giorniLvorativi;
    return workingDays || 21;
  };

  return (
    <>
      {visibleRows[TotalsRevenuesAndGUStickyLabels.totalGu.key] && (
        <tr key={'tot-gu'} id="tot-gu">
          {fullAllocationsShown?.[0].allocazioni?.map((allocation: AllocationDto, index: number) => (
            <td className="text-end p-0" key={'GU-per-month-' + index} style={{ minWidth: '100px' }}>
              <span className="span-table-values">
                {formatCurrency(
                  fullAllocationsShown
                    ?.map((el) => el.allocazioni?.[index]?.actualAllocation)
                    .reduce((acc, el) => (acc || 0) + (el || 0), 0) ?? 0
                )}
              </span>
            </td>
          ))}
        </tr>
      )}
      {visibleRows[TotalsRevenuesAndGUStickyLabels.fte.key] && (
        <tr key={'fte'} id="fte">
          {fullAllocationsShown?.[0].allocazioni?.map((allocation: AllocationDto, index: number) => (
            <td className="text-end p-0" key={'fte-per-month-' + index}>
              <span className="span-table-values">
                {formatCurrency(
                  (fullAllocationsShown
                    ?.map((el) => el.allocazioni?.[index]?.actualAllocation)
                    .reduce((acc, el) => (acc || 0) + (el || 0), 0) ?? 0) / getGiorniLavorativi(index)
                )}
              </span>
            </td>
          ))}
        </tr>
      )}
      {visibleRows[TotalsRevenuesAndGUStickyLabels.workingDays.key] && (
        <tr key={'working-days'} id="working-days">
          {fullAllocationsShown?.[0].allocazioni?.map((allocation: AllocationDto, index: number) => (
            <td className="text-end p-0" key={'working-days-' + index}>
              <span className="span-table-values">{formatCurrency(getGiorniLavorativi(index))}</span>
            </td>
          ))}
        </tr>
      )}
      {visibleRows[TotalsRevenuesAndGUStickyLabels.personnelCosts.key] && (
        <tr key={'costi-personale'} id="costi-personale">
          {totalsRevenuePlanShown?.map((el: RevenuePlanDto, index: number) => (
            <td
              className="text-end p-0"
              key={'costi-personale-per-month-' + index + '-' + el.actualAmount}
              style={{ minWidth: '100px' }}
            >
              <span className="span-table-values">{formatCurrency(el.actualHrCost)}</span>
            </td>
          ))}
        </tr>
      )}
      {visibleRows[TotalsRevenuesAndGUStickyLabels.externalCosts.key] && (
        <tr key={'costi-esterni'} id="costi-esterni">
          {totalsRevenuePlanShown?.map((el: RevenuePlanDto, index: number) => (
            <td className="text-end p-0" key={'costi-esterni-per-month-' + index} style={{ minWidth: '100px' }}>
              <span className="span-table-values">{formatCurrency(el.actualExternalCost)}</span>
            </td>
          ))}
        </tr>
      )}
      {visibleRows[TotalsRevenuesAndGUStickyLabels.totalCosts.key] && (
        <tr key={'costi-totali'} id="costi-totali">
          {totalsRevenuePlanShown?.map((el: RevenuePlanDto, index: number) => (
            <td className="text-end p-0" key={'costi-totali-per-month-' + index} style={{ minWidth: '100px' }}>
              <span className="span-table-values">{formatCurrency(el.actualCost)}</span>
            </td>
          ))}
        </tr>
      )}

      {visibleRows[TotalsRevenuesAndGUStickyLabels.rate.key] && (
        <tr key={'rate'} id="rate">
          {totalsRevenuePlanShown?.map((el: RevenuePlanDto, index: number) => (
            <td className="text-end p-0" key={'rate-per-month-' + index} style={{ minWidth: '100px' }}>
              <span className="span-table-values">{formatCurrency(el.actualRate)}</span>
            </td>
          ))}
        </tr>
      )}
      {visibleRows[TotalsRevenuesAndGUStickyLabels.revenues.key] && (
        <tr key={'ricavi'} id="ricavi">
          {totalsRevenuePlanShown?.map((el: RevenuePlanDto, index: number) => (
            <td className="text-end p-0" key={'ricavi-per-month-' + index} style={{ minWidth: '100px' }}>
              <span className="span-table-values">{formatCurrency(el.actualAmount)}</span>
            </td>
          ))}
        </tr>
      )}
    </>
  );
};

export default TotalsAllocations;
